
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"40","height":"40","rx":"20","fill":"#036FFD"}}),_c('path',{attrs:{"d":"M29.32 13.05l-6-2h-.07a.697.697 0 00-.14 0h-.43L17 13l-5.68-1.95a1 1 0 00-.9.14A1.001 1.001 0 0010 12v14a1 1 0 00.68.95l6 2a1 1 0 00.62 0l5.7-1.9L28.68 29c.106.014.214.014.32 0a.94.94 0 00.58-.19A1.001 1.001 0 0030 28V14a1 1 0 00-.68-.95zM16 26.61l-4-1.33V13.39l4 1.33v11.89zm6-1.33l-4 1.33V14.72l4-1.33v11.89zm6 1.33l-4-1.33V13.39l4 1.33v11.89z","fill":"#fff"}})])
          )
        }
      }
    